module.exports = __webpack_public_path__ + "img/partseven_user2.fee73c39.png";